import { GET_SMS_TEMPLATES_URL, SEND_SMS_URL } from "../utils/api-url";
import { postCall } from "../utils/network.util";


export const getSmsTemplates = (onSuccess,onFailure)=>{
    const getSmsTemplates = postCall(GET_SMS_TEMPLATES_URL, {});
    getSmsTemplates.then((data) => {
        if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
            onSuccess(data.payload.Payload);
        }else{
            onFailure("Failed to get sms templates!");
        }
    })
    .catch((reason)=> {
        console.error({reason});
        onFailure("Failed to get sms templates!");
    })
}

export const sendSms = (smsData,tripId,sentLocation,onSuccess,onFailure)=>{
    
    const sendSms = postCall(SEND_SMS_URL, {...smsData,tripId,operatorCode:global.operatorCode,sentLocation});
    sendSms.then((data) => {                
        if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
            onSuccess(data.payload.Payload);
        }else{
            onFailure("Failed to send sms!");
        }
    })
    .catch((reason)=> {
        console.error({reason});
        onFailure("Failed to send sms!");
    })
}
